export const objectIsEmpty = (obj) => !!(obj && Object.getOwnPropertyNames(obj).length === 0);

export const objectToArray = (obj) => {
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return null;

  const array = [];
  for (const [key, value] of Object.entries(obj)) {
    array.push({ key, value });
  }

  return array;
};
